import { CallParticipant, TranscriptQuote } from '../../../teams-call';

export function filterQuotesByParticipants(
    participants: CallParticipant[] | null,
    quotes: TranscriptQuote[],
): TranscriptQuote[] {
    if (participants == null || participants.length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return participants.some((e) => {
            return (
                (e.userId != null && e.userId === q.userId) ||
                (e.userName ?? e.msftDisplayName)?.toLowerCase() ===
                    (q.userName ?? q.msftDisplayName)?.toLowerCase()
            );
        });
    });
}
